








import { Component, Vue, Prop } from 'vue-property-decorator';
import Form from '@/classes/Form';
import * as Bowser from 'bowser';

@Component
export default class BrowserAlert extends Vue {
    public browser = Bowser.getParser(window.navigator.userAgent);

    public get isValidDesktopBrowser(): boolean {
        const bool: boolean | undefined = this.browser.satisfies(
            {
                chrome: '>19',
                firefox: '>56',
                opera: '*',
                edge: '>12'
            });
        if (bool === undefined) {
            return false;
        } else {
            return bool;
        }
    }

    public get isMobileBrowser(): boolean {
        const platform: Bowser.Parser.PlatformDetails = this.browser.getPlatform();
        return platform.type !== undefined ? platform.type.localeCompare('mobile') === 0 : false;
    }

    public get isTabletBrowser(): boolean {
        const platform: Bowser.Parser.PlatformDetails = this.browser.getPlatform();
        return platform.type !== undefined ? platform.type.localeCompare('tablet') === 0 : false;
    }

    public get isValidBrowser(): boolean {
        return (this.isValidDesktopBrowser || this.isMobileBrowser || this.isTabletBrowser);
    }
}
